import { useState } from 'react';
import {
  TablePagination,
  Box,
  Typography,
  Table,
  TableBody,
  TableRow,
  TableHead,
} from '@mui/material';
import {
  DialogContainer,
  DialogBody,
  GeneralTableBox,
  HeadTableCell,
  RowTableCell,
} from '../../../../common/components';
import { useExcelExport } from '../../hooks/useExcelExport';
import { usePDFExport } from '../../hooks/usePDFExport';
import { PAGINATION_CONFIG } from '../../constants/statisticsConstants';
import StatisticsDialogTitle from '../common/StatisticsDialogTitle';

const DeferredCouponsModal = ({ open, handleClose, header, results }) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(PAGINATION_CONFIG.DEFAULT_ROWS_PER_PAGE);

  const { exportToExcel } = useExcelExport();
  const { exportToPDF } = usePDFExport();

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleExportToExcel = () => {
    const data = results.map((result) => ({
      'Número de Contrato': result.numero_orden,
      Suscriptor: result.subscriber_name,
      Cuotas:
        result.fee_number2 && result.fee_number2 !== 0
          ? `${result.fee_number1} - ${result.fee_number2}`
          : `${result.fee_number1}`,
      'Fecha Primer Vencimiento': result.first_due_date,
      'Porcentaje Diferido': result.porcentage_diferido,
      'Días Diferidos': result.dias_diferido,
    }));

    exportToExcel(data, 'CuponesDiferidos');
  };

  const handleExportToPDF = () => {
    const pdfData = {
      title: 'Reporte de Cupones Diferidos',
      headers: ['N°', 'Suscriptor', 'Cuotas', 'Primer Venc.', '% Dif.', 'Días Diferidos'],
      data: results.map((result) => [
        result.numero_orden.toString(),
        result.subscriber_name,
        result.fee_number2 && result.fee_number2 !== 0
          ? `${result.fee_number1} - ${result.fee_number2}`
          : `${result.fee_number1}`,
        result.first_due_date,
        `${result.porcentage_diferido}%`,
        result.dias_diferido.toString(),
      ]),
      filename: 'CuponesDiferidos',
    };

    exportToPDF(pdfData);
  };

  if (!header || !results || results.length === 0) {
    return null;
  }

  const paginatedResults = results.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  return (
    <DialogContainer open={open} onClose={handleClose} size="fullWidth">
      <StatisticsDialogTitle
        title="Cupones Diferidos"
        onExportExcel={handleExportToExcel}
        onExportPDF={handleExportToPDF}
        onClose={handleClose}
      />
      <DialogBody>
        <Box
          sx={{ mb: 3, textAlign: 'center', border: '1px solid #4a90e2', p: 2, borderRadius: 2 }}
        >
          <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#333', mb: 1 }}>
            {header.constructora_info}
          </Typography>
          <Typography variant="body2" sx={{ color: '#555', fontStyle: 'italic', mb: 0.5 }}>
            Actualizado a la fecha: {header.updated_at_date}
          </Typography>
          <Typography variant="body2" sx={{ color: '#555' }}>
            {header.date_filter_text}
          </Typography>
        </Box>

        <Typography variant="body2" sx={{ mb: 2, fontSize: '0.875rem', color: '#555' }}>
          Cantidad de cupones encontrados: {results.length}
        </Typography>

        <GeneralTableBox>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <HeadTableCell>N° de Contrato</HeadTableCell>
                <HeadTableCell>Suscriptor</HeadTableCell>
                <HeadTableCell>Cuotas</HeadTableCell>
                <HeadTableCell>Primer vencimiento</HeadTableCell>
                <HeadTableCell>Porcentaje diferido</HeadTableCell>
                <HeadTableCell>Días diferidos</HeadTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {paginatedResults.map((result, index) => (
                <TableRow key={index}>
                  <RowTableCell>{result.numero_orden}</RowTableCell>
                  <RowTableCell>{result.subscriber_name}</RowTableCell>
                  <RowTableCell>
                    {result.fee_number2 && result.fee_number2 !== 0
                      ? `${result.fee_number1} - ${result.fee_number2}`
                      : result.fee_number1 !== 0
                      ? `${result.fee_number1}`
                      : 'Adecuación'}
                  </RowTableCell>
                  <RowTableCell>{result.first_due_date}</RowTableCell>
                  <RowTableCell>{result.porcentage_diferido} %</RowTableCell>
                  <RowTableCell>{result.dias_diferido}</RowTableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </GeneralTableBox>

        <TablePagination
          component="div"
          count={results.length}
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          labelRowsPerPage="Cupones por página"
          rowsPerPageOptions={PAGINATION_CONFIG.ROWS_PER_PAGE_OPTIONS}
        />
      </DialogBody>
    </DialogContainer>
  );
};

export default DeferredCouponsModal;
